// Resolve a reward by name for the by-name slideout/tooltip consumers. Top-level rewards
// win; falls back to an aggregated reward's nested child (e.g. Veriha fuel's mpg/idle),
// which exists only under `reward.rewards[]` and so is absent from the flat top-level
// lookup. Without this fallback a board section keyed by a child name never resolves and
// its `BonusRewardBody` Gate spins forever.
const resolveRewardWithCriteria = ({
  rewards,
  criteria,
  rewardName,
}: {
  rewards: BonusTypes.Rewards.AnyRewardOutput[];
  criteria: BonusTypes.Rewards.CriteriaOutput[];
  rewardName: string;
}): BonusTypes.RewardWithCriteria | undefined => {
  const matchCriteria = criteria.filter((c) => c.reward === rewardName);

  const topLevel = rewards.find((r) => r.name === rewardName);
  if (topLevel) {
    return { reward: topLevel, criteria: matchCriteria };
  }

  for (const parent of rewards) {
    const child = parent.rewards?.find((c) => c.name === rewardName);
    if (child) {
      return { reward: child, criteria: matchCriteria };
    }
  }

  return undefined;
};

export default resolveRewardWithCriteria;
